import { storeRequester } from "App";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import CardList from "layouts/wrapper/CardList";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { rpad2D } from "shared/utils/Utils";
// /import MobileSearchBar from "components/MobileSearchBar";
import NiceModal from "@ebay/nice-modal-react";
import Container from "layouts/container/Container";
import { AuthContext } from "providers/AuthProvider";
import callImg from "resources/img/main/call.png";
import guideImg from "resources/img/main/guide.png";
import shippingImg from "resources/img/main/shipping.png";

import Dummy from "components/Dummy";
import guideDetailImg from "resources/img/main/guideDetail.png";
import "swiper/css/effect-creative";
import "swiper/css/effect-fade";
import MobileHome from "./MobileHome";

function Home() {
  const { isMobile } = useContext(BrowserDetectContext);
  const { userName } = useContext(AuthContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [restockProducts, setRestockProducts] = useState([]);
  const obsRef = useRef(null);
  const [page, setPage] = useState(1);
  const pageRef = useRef(1);
  const [medusaProducts, setMedusaProducts] = useState([]);
  const [banners, setBanners] = useState([]);
  const [simplePopup, setSimplePopup] = useState({ index: null, detail: null }); // 클릭된 팝업 상태

  // 팝업에 표시할 내용
  const popupContent = {
    call: {
      title: "고객센터",
      content:
        "연락처 : \n010-2349-8677, \n070-4187-5511\n\n영업시간: 월 ~ 금 9:30 ~ 17:30 (공휴일휴무)\n점심시간: 12:00 ~13:00",
    },
    shipping: {
      title: "택배안내",
      content:
        "택배사: CJ 대한통운 \n택배는 당일 16시 결제건까지 당일 발송 됩니다.\n이후 결제건은 익일(주말 및 공휴일 제외) 발송됩니다.",
    },
  };

  const handleBoxClick = (detail, img, index) => {
    if (detail === "guide") {
      setSimplePopup({ index: null, detail: null }); // 팝업 초기화
      NiceModal.show("supportDetail", { detail: detail, detailImg: img });
    } else {
      setSimplePopup({ index, detail }); // 클릭된 박스의 인덱스와 detail 저장
    }
  };

  const closeSimplePopup = () => setSimplePopup({ index: null, detail: null }); // 팝업 닫기

  const chunkArray = (array, size) =>
    Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
      array.slice(i * size, i * size + size)
    );

  const containerRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;
      const currentScrollLeft = window.scrollX;

      setScrollTop(currentScrollTop);
      setScrollLeft(currentScrollLeft);
    };

    window.addEventListener("scroll", handleScroll);

    const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 });
    if (obsRef.current) {
      observer.observe(obsRef.current);
    }

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const search = (page) => {
    let data = { page: page ? page : 0, pageSize: 10 };
  };

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  const obsHandler = (entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      search(pageRef.current);
    }
  };

  useEffect(() => {
    // to-map limit , offset을 이용한 페이징, price : 가격, discount_price 할인된 가격
    storeRequester.getProducts(
      {
        type: "main",
        mix: true,
        limit: 100,
        offset: 0,
        // q : 검색용
        // category_id : 카테고리 아이디 검색
        // order : 정렬(인기,신규,낮은,높은) 순서대로 0,1,2,3
      },
      ({ products }) => setMedusaProducts(products)
    );

    storeRequester.getDiscounts(
      {
        code: "RESTOCK",
        // code: "NEW",
        type: "main",
      },
      ({ data }) => {
        setRestockProducts(
          rpad2D(
            ([
              ...(data.variants || []),
              ...(data?.products || [])?.map((product) => product?.variants || []).flat(),
            ].reduce((list, data) => {
              const find = list.find((item) => item.id === data.id);
              if (!find) {
                return [...list, data];
              }
              return list;
            }, [])), (isMobile ? 3 : 5)
          )
        );

      }
    );

    // to-map 브랜드, QuillViewer를 사용, ArticleDetailModal 참조, 클릭시 이동 링크는 metadata.link 에 담겨있음
    storeRequester.getArticle(
      {
        expand: "board",
         border_name: "banner",
        limit: 3,
      },
      ({ articles }) => setBanners(articles)
    );
  }, []);


  const supportBoxArray = [
    {
      img: guideImg,
      text: "가입안내",
      detail: "guide",
      detailImg: guideDetailImg,
    },
    {
      img: shippingImg,
      text: "택배안내",
      detail: "shipping",
    },
    {
      img: callImg,
      text: "고객센터",
      detail: "call",
    },
  ];

  return (
    <>
      {isMobile ? (
        <MobileHome
          banner={banners}
          restockProducts={restockProducts}
          medusaProducts={medusaProducts}
          
        />
      ) : (
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
          <Dummy height={"50px"} />
          <Container>
            <Container minWidth={1400} maxWidth={1400}>
              <HorizontalFlex flexStart gap={10}>
                <FlexChild width={"100px"}>
                  <div style={{ position: "relative", width: "100px" }}>
                    {/* <div
                      className={style.supportWrap}
                      ref={containerRef}
                      style={{
                        position: "absolute",
                        top: `${scrollTop + 170}px`, 
                        
                      }}
                    >
                      <VerticalFlex gap={10}>
                        {supportBoxArray.map((row, index) => (
                          <FlexChild>
                            <div key={index} style={{ position: "relative" }}>
                              {" "}
                              
                              <div
                                onClick={() =>
                                  handleBoxClick(
                                    row.detail,
                                    row.detailImg,
                                    index
                                  )
                                }
                                style={{
                                  border: "1px solid rgba(201, 202, 202, 1)",
                                  borderRadius: "10px",
                                  height: "100px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "column",
                                  gap: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <img src={row.img} width={"30px"} />
                                <P size={16} color={"black"}>
                                  {row.text}
                                </P>
                              </div>
                              
                              {simplePopup.index === index &&
                                simplePopup.detail && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: `50%`, 
                                      left: "100%", 
                                      transform: "translateY(-50%)", 
                                      width: "200px",
                                      padding: "10px",
                                      backgroundColor: "#fff",
                                      border: "1px solid #ddd",
                                      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                                      zIndex: 1000,
                                      borderRadius: "5px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <span style={{ fontWeight: "bold" }}>
                                        {
                                          popupContent[simplePopup.detail]
                                            ?.title
                                        }
                                      </span>
                                      <button
                                        onClick={closeSimplePopup}
                                        style={{
                                          border: "none",
                                          background: "none",
                                          cursor: "pointer",
                                        }}
                                      >
                                        ✕
                                      </button>
                                    </div>
                                    <p style={{ fontSize: "14px" }}>
                                      {
                                        popupContent[simplePopup.detail]
                                          ?.content
                                      }
                                    </p>
                                  </div>
                                )}
                            </div>
                          </FlexChild>
                        ))}
                      </VerticalFlex>
                    </div> */}
                  </div>
                </FlexChild>
                <FlexChild>
                  <Container minWidth={1300} maxWidth={1300}>
                    <VerticalFlex
                      gap={isMobile ? 30 : 60}
                      padding={isMobile ? 0 : "0px 10px"}

                    >
                      {/* {banners && banners.length > 0 && (
                        <FlexChild marginTop={50}>
                          <BannerSwiper data={banners} />
                        </FlexChild>
                      )} */}
                      {/* <FlexChild padding={"80px 20px"}>
                        <div style={{ position: "relative" }}>
                          <div
                            style={{
                              position: "absolute",
                              top: "-55px",
                              zIndex: 9,
                            }}
                          >
                            <FlexChild alignItems={"flex-start"}>
                              <P size={24} weight={700}>
                                {t("새로나온 액상을 확인해보세요!")}
                              </P>
                            </FlexChild>
                          </div>
                          <NewProductSwiper />
                        </div>
                      </FlexChild> */}
                      {/* <FlexChild>
                        <EventSwiper />
                      </FlexChild> */}
                      {/* <FlexChild>
                        <div
                          style={{
                            width: "100%",
                            height: "2px",
                            backgroundColor: "rgba(201, 202, 202, 1)",
                          }}
                        />
                      </FlexChild> */}
                      {/* <FlexChild>
                        <div style={{ position: "relative" }}>
                          <VerticalFlex>
                            {
                              restockProducts && restockProducts.length > 0 &&
                              <FlexChild padding={"50px 20px"}>
                                <div style={{ position: "relative" }}>
                                  <div
                                    style={{ position: "absolute", top: "-20px" }}
                                  >
                                    <FlexChild>
                                      <Center width={"100%"} textAlign={"left"}>
                                        <P size={24} weight={"bold"}>
                                          재입고 된 액상
                                        </P>
                                      </Center>
                                    </FlexChild>
                                  </div>
                                  <ProgressbarSwiper
                                    totalSlides={
                                      restockProducts && restockProducts.length
                                    }
                                  >
                                    {restockProducts &&
                                      restockProducts.map((slide, index) => (
                                        <SwiperSlide key={index}>
                                          <div
                                            style={{ backgroundColor: "white" }}
                                          >
                                            <Swiper
                                              autoplay={{
                                                delay: 1000,
                                                disableOnInteraction: false,
                                                pauseOnMouseEnter: true,
                                              }}
                                              slidesPerView={5}
                                              spaceBetween={30}
                                              modules={[Autoplay]}
                                            >
                                              {slide &&
                                                slide.map(
                                                  (product, index) => (

                                                    product.id &&
                                                    <SwiperSlide key={index}>
                                                      <ProductCard
                                                        data={{
                                                          ...product,
                                                          thumbnail:
                                                            product.thumbnail,
                                                          title: product.title,
                                                        }}
                                                        template={"normal"}
                                                        restock
                                                      />
                                                    </SwiperSlide>

                                                  )
                                                )}
                                            </Swiper>
                                          </div>
                                        </SwiperSlide>
                                      ))}
                                  </ProgressbarSwiper>
                                  
                                </div>
                              </FlexChild>
                            }
                          </VerticalFlex>
                        </div>
                      </FlexChild> */}
                      {/* <FlexChild
                        // backgroundColor={"var(--main-color-light)"}
                        borderRadius={"10px"}
                      >
                        <WeeklyBestSeller />
                      </FlexChild> */}
                      <FlexChild>
                        {medusaProducts && medusaProducts.length > 0 && (
                          <CardList
                            title={"전체상품"}
                            data={medusaProducts}
                            template={"addWish"}
                          />
                        )}
                      </FlexChild>
                      <FlexChild>
                        <div ref={obsRef}></div>
                      </FlexChild>
                    </VerticalFlex>
                  </Container>
                </FlexChild>
              </HorizontalFlex>
            </Container>
          </Container>
        </div>
      )}
    </>
  );
}

export default Home;
